import { uid } from "../util/uid";
import { blockRegistry } from "../registry/blocks";

export const SCHEMA_VERSION = 1;

export const defaultSettings = {
  contentWidth: 600,
  backgroundColor: "#f5f7f9",
  cardColor: "#ffffff",
  fontFamily: "'Poppins', Arial, Helvetica, sans-serif",
  textColor: "#333333",
  linkColor: "#069d6e",
};

export const createBlock = (type) => {
  const def = blockRegistry[type];
  if (!def) throw new Error(`Unknown block type: ${type}`);
  return {
    id: uid(type),
    type,
    props: JSON.parse(JSON.stringify(def.defaultProps)),
  };
};

export const emptyDoc = () => ({
  version: SCHEMA_VERSION,
  settings: { ...defaultSettings },
  blocks: [
    createBlock("heading"),
    createBlock("text"),
    createBlock("button"),
  ],
});

export const isBuilderDoc = (value) =>
  value &&
  typeof value === "object" &&
  Array.isArray(value.blocks) &&
  typeof value.version === "number";
